import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
mutation newResultMutation(
    $reportId: Int,
    $indicatorId: Int,
    $successCriteria: String,
    $classification: String,
    $description: String,
    $forecastInitial: Float,
    $forecastCurrent: Float,
    $relevant: Boolean,
) {
  newResult(
    reportId: $reportId,
    indicatorId: $indicatorId,
    successCriteria: $successCriteria,
    classification: $classification,
    description: $description,
    forecastInitial: $forecastInitial,
    forecastCurrent: $forecastCurrent,
    relevant: $relevant,
) {
    id
    success
  }
}
`;

export function useNewResult() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newResult.id);
      }
    });
  };
  return { data, isLoading, run };
}
